import MasterData from "../../../jsx/components/Dashboard/MasterData/MasterData";

const MasterdataWrapper = () => {
  return <MasterData />;
};

export default constore(MasterdataWrapper);
